<template>
  <div class="container">
    <form @submit="save">
      <div class="p-fluid p-formgrid">
        <div class="row">
          <div class="p-field col-12 mt-2">
            <h4>Informações da Frente de Trabalho</h4>
          </div>

          <div class="p-field col-12">
            <label>Nome <span class="text-danger">*</span></label>
            <InputText v-model="form.name" />
          </div>
          <div class="p-field col-12">
            <label>Responsável <span class="text-danger">*</span></label>
            <div class="d-flex">
              <select
                class="form-control"
                :value="form.responsible"
                @change="selectResponsible($event)"
              >
                <option selected disabled>Escolha o responsável</option> 
                <option v-for="user in dropdown_data.users"
                        :selected="user.id == form?.responsible"
                        :disabled="selectedUsers.includes(user.id)"
                        :value="user.id"
                        v-bind:key="user.id"
                >{{ user.name }}
                </option>
              </select>
              <button class="btn text-danger" type="button" @click="selectResponsible()">
                <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
              </button>
            </div>
          </div>
          <div class="p-field col-12">
            <label>Responsável Terceiro</label>
            <div class="d-flex">
              <select
                class="form-control"
                :value="form.responsible_third_party"
                @change="selectResponsibleThirdParty($event)"
              >
                <option selected disabled>Escolha o responsável terceiro</option> 
                <option v-for="user in dropdown_data.users"
                        :selected="user.id == form?.responsible_third_party"
                        :disabled="selectedUsers.includes(user.id)"
                        :value="user.id"
                        v-bind:key="user.id"
                >{{ user.name }}
                </option>
              </select>
              <button class="btn text-danger" type="button" @click="selectResponsibleThirdParty()">
                <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
              </button>
            </div>
          </div>
          <div class="p-field col-12">
            <label>Supervisor Adequação</label>
            <div class="d-flex">
              <select
                class="form-control"
                :value="form.adequacy_supervisor"
                @change="selectAdequacySupervisor($event)"
              >
                <option selected disabled>Escolha o supervisor de adequação</option> 
                <option v-for="user in dropdown_data.users"
                        :selected="user.id == form?.adequacy_supervisor"
                        :disabled="selectedUsers.includes(user.id)"
                        :value="user.id"
                        v-bind:key="user.id"
                >{{ user.name }}
                </option>
              </select>
              <button class="btn text-danger" type="button" @click="selectAdequacySupervisor()">
                <font-awesome-icon :icon="['fas', 'times']"></font-awesome-icon>
              </button>
            </div>
          </div>

          <hr />

          <div class="p-field col-12 mt-2 d-flex align-items-center">
            <h4 class="mr-3">Escopo</h4>
            <SelectButton
              v-model="selectedScope"
              :options="scopes"
              optionLabel="name"
              optionValue="value"
              :multiple="false"
            />
          </div>

          <div class="p-field col-12" v-if="selectedScope == 'sector'">
            <label>Setores</label>
            <MultiSelect
              v-model="form.sectors"
              :options="dropdown_data.sectors"
              display="chip"
              option-label="name"
              option-value="id"
            >
            </MultiSelect>
          </div>
          <div class="col-12 p-0" v-else>
            <div class="p-field col-12">
              <label>Graus de Risco NR-12</label>
              <MultiSelect
                v-model="form.degreesNR12"
                :options="dropdown_data.degreesNR12"
                display="chip"
                option-label="name"
                option-value="id"
              >
              </MultiSelect>
            </div>
            <div class="p-field col-12">
              <label>Graus de Risco NR-33</label>
              <MultiSelect
                v-model="form.degreesNR33"
                :options="dropdown_data.degreesNR33"
                display="chip"
                option-label="name"
                option-value="id"
              >
              </MultiSelect>
            </div>
          </div>

          <hr />

          <div class="p-field col-12 mt-2">
            <h4>Equipe</h4>
          </div>
          <div class="p-field col-12">
            <label>Membros</label>
            <MultiSelect
              v-model="form.members"
              :options="dropdown_data.users"
              display="chip"
              option-label="name"
              option-value="id"
              :filter="true"
            >
            </MultiSelect>
          </div>
        </div>
      </div>
    
      <div class="row mt-3">
        <div class="col-12">
          <button class="btn btn-primary" type="submit" :disabled="!form.name || !form.responsible">{{ submit_text }}</button>
          <button class="btn btn-danger ml-3" type="button" @click="openTable()">Cancelar</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { useRouter, useRoute } from 'vue-router';
  import InputText from 'primevue/inputtext';
  import Dropdown from 'primevue/dropdown';
  import Textarea from 'primevue/textarea';
  import InputNumber from 'primevue/inputnumber';
  import RadioButton from 'primevue/radiobutton';
  import SelectButton from 'primevue/selectbutton';
  import MultiSelect from 'primevue/multiselect'
  import { computed, onMounted } from 'vue';
  import useWorkFront from '@/modules/WorkFront.js';
  import { useStore } from 'vuex';
  import Swal from 'sweetalert2/src/sweetalert2.js';
  import axios from 'axios';
  
  export default {
    components: {
      InputText,
      Dropdown,
      Textarea,
      InputNumber,
      RadioButton,
      SelectButton,
      MultiSelect,
    },
    data() {
      return {
        selectedScope: 'sector',
        selectedUsers: [],
        submit_text: '',
        form: {
          name: '',
          responsible: '',
          responsible_third_party: '',
          adequacy_supervisor: '',
          sectors: [],
          degreesNR12: [],
          degreesNR33: [],
          members: '',
          membersSplitted: [],
          company_id: null,
        },
      }
    },
    setup() {
      const route = useRoute()
      const router = useRouter()
      const store = useStore()
      const selected_company = computed(() => store.getters.selected_company)

      const {
        dropdown_data,
        storeOrUpdateWorkFront,
        getDropdownData
      } = useWorkFront()
      
      onMounted(async () => {
          getDropdownData(selected_company.value.id)
      })

      const scopes = [
        { name: 'Setor', value: 'sector' },
        { name: 'Grau de Risco', value: 'degree' },
      ]

      const isEditing = route.params.id ? true : false

      return {
        router,
        storeOrUpdateWorkFront,
        dropdown_data,
        selected_company: selected_company.value.id,
        scopes,
        isEditing,
      }
    },
    mounted() {
      if (this.isEditing) {
        const id = this.$route.params.id
        this.getWorkFrontData(id)
        this.submit_text = 'Salvar alterações'
      } else {
        this.submit_text = 'Cadastrar'
      }
    },
    methods : {
      async getWorkFrontData(id) {
        const data = await this.axios.get(`/api/work-front/get/${id}`)
          .then(({data}) => data.data)
          .catch(error => {
            console.log(error)
            return null
          })

        if (!data) return
        
        this.form.id = data.id
        this.form.priority = data.priority
        this.form.company_id = data.company_id
        this.form.name = data.name
        this.form.responsible = data.responsible_id
        this.form.responsible_third_party = data.responsible_third_party_id
        this.form.adequacy_supervisor = data.adequacy_supervisor_id
        this.form.members = data.members

        this.selectedUsers.push(
          data.responsible_id,
          data.responsible_third_party_id,
          data.adequacy_supervisor_id
        )

        if (data.sectors.length > 0) {
          this.selectedScope = 'sector'

          this.form.sectors = data.sectors.map(sector => sector.id)
        }

        if (data.degreesNR12.length > 0 || data.degreesNR33.length > 0) {
          this.selectedScope = 'degree'

          this.form.degreesNR12 = data.degreesNR12.map(degree => degree.id)
          this.form.degreesNR33 = data.degreesNR33.map(degree => degree.id)
        }

        if (data.members.length > 0) {
          this.form.members = data.members.map(member => member.id)
        }
      },
      openTable() {
        this.router.push('/work-front');
      },
      save(event) {
        event.preventDefault()

        const sectors = Object.values(Object.assign({}, this.form.sectors))
        const degreesNR12 = Object.values(Object.assign({}, this.form.degreesNR12))
        const degreesNR33 = Object.values(Object.assign({}, this.form.degreesNR33))
        const members = Object.values(Object.assign({}, this.form.members))

        let dataStore = {
          id: this.form.id,
          priority: this.form.priority,
          name: this.form.name,
          company_id: this.selected_company,
          responsible_id: this.form.responsible,
          responsible_third_party_id: this.form.responsible_third_party,
          adequacy_supervisor_id: this.form.adequacy_supervisor,
          members,
          scope: this.selectedScope,
          sectors,
          degreesNR12,
          degreesNR33,
        };

        this.storeOrUpdateWorkFront(dataStore).then((response) => {
          if(response.status) {
            axios.post('api/workFrontCreationMail', dataStore)

            Swal.fire(
              'Sucesso',
              'A frente de trabalho foi salva.',
              'success'
            );
            this.openTable();
          }
        }).catch((error) => {
          console.log(error);
        });
      },

      selectResponsible(event) {
        if (this.form.responsible) {
          const index = this.selectedUsers.indexOf(this.form.responsible)
          this.selectedUsers.splice(index, 1)
        }

        if (event) {
          const value = parseInt(event.target.value)
          this.form.responsible = value
          this.selectedUsers.push(value)
        } else {
          this.form.responsible = null
        }
      },

      selectResponsibleThirdParty(event) {
        if (this.form.responsible_third_party) {
          const index = this.selectedUsers.indexOf(this.form.responsible_third_party)
          this.selectedUsers.splice(index, 1)
        }

        if (event) {
          const value = parseInt(event.target.value)
          this.form.responsible_third_party = value
          this.selectedUsers.push(value)
        } else {
          this.form.responsible_third_party = null
        }
      },

      selectAdequacySupervisor(event) {
        if (this.form.adequacy_supervisor) {
          const index = this.selectedUsers.indexOf(this.form.adequacy_supervisor)
          this.selectedUsers.splice(index, 1)
        }
        
        if (event) {
          const value = parseInt(event.target.value)
          this.form.adequacy_supervisor = value
          this.selectedUsers.push(value)
        } else {
          this.form.adequacy_supervisor = null
        }
      },
    },
    watch: {
      selectedScope(newValue) {
        if (newValue == 'sector') {
          this.form.degreesNR12 = []
          this.form.degreesNR33 = []
        } else {
          this.form.sectors = []
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .p-selectbutton {
    max-height: 30px;
    width: 250px;

    ::v-deep(.p-highlight) {
      background: #007bff !important;
    }
  }
</style>
